import React from 'react';

const CategoryTabs = ({ activeCategory, onCategoryChange, isAuthenticated }) => {
  const categories = [
    { id: 'provider', name: 'My Templates', icon: '👨‍⚕️' },
    { id: 'health_system', name: 'Healthcare', icon: '🏥' },
    { id: 'global', name: 'System', icon: '🌐' }
  ];

  return (
    <div className="category-tabs">
      {categories.map(category => (
        <div key={category.id} className={`category-tab ${activeCategory === category.id ? 'active' : ''}`} onClick={() => onCategoryChange(category.id)}>
          <span style={{ fontSize: '16px', paddingRight: '10px' }}>{category.icon}</span>
          <span>{category.name}</span>
          {!isAuthenticated && category.id === 'provider' && <span style={{ fontSize: '12px', opacity: 0.6, marginLeft: '4px' }}>🔒</span>}
        </div>
      ))}
    </div>
  );
};

export default CategoryTabs;